/** Where a session goes when its saved route no longer resolves to a page. */
export const SAVED_ROUTE_FALLBACK = '/results/confirmed';

/**
 * The route the catch-all sends a ready session to. A job's saved `form_step`
 * can name a page that has since been removed (the `/feedback` pages saved their
 * own path on submit). Returning that path again from the catch-all would match
 * the catch-all again, so an unmatched saved route falls back to the booking.
 */
export function resolveSavedSessionRoute(savedRoute: string | null | undefined, requestedPath: string): string {
    if (!savedRoute || savedRoute === requestedPath || savedRoute.startsWith('/feedback')) {
        return SAVED_ROUTE_FALLBACK;
    }

    return savedRoute;
}
